module.exports = __webpack_public_path__ + "img/akun-active.75f17e06.svg";